const notificationRowData = {
  _id: "",
  notification: {
    _id: "",
    title: "",
    body: "",
    module: "",
    priority: "",
    actionUrl: null,
    account: {
      _id: "",
      name: "",
    },
    sender: {
      _id: "",
      lastName: "",
      email: "",
      firstName: "",
    },
  },
  isRead: "",
  readAt: "",
  createdAt: "",
};

export default notificationRowData;
